export let StakingModalName;

(function (StakingModalName) {
  StakingModalName["UNSTAKING"] = "unstaking";
  StakingModalName["CLAIM"] = "claim";
  StakingModalName["CONFIRM_UNSTAKE"] = "confirm-unstake";
})(StakingModalName || (StakingModalName = {}));